import React, { FC } from "react";
import { SingleFilter } from "./singleFilter";
import { getFilterProps } from "./helper";
import { IconRatio } from "../../../../utils/icons";
import { ASPECT_RATIO_OPTIONS } from "../../../../utils/aspectRatios";

interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  queryFilters?: any;
}

export const AspectRatioFilter: FC<Props> = ({ onFilterSelect, ...rest }) => {
  return (
    <SingleFilter
      {...rest}
      {...getFilterProps(ASPECT_RATIO_OPTIONS, "aspectRatio")}
      icon={IconRatio}
      updateSearch={onFilterSelect}
    />
  );
};
